const state = {
    drawer: false,
    menuList: [
        {title: 'Create', link: '/create'},
        {title: 'Manage', link: '/manage'},
        {title: 'Instaplays', link: '/home'}
    ]
}

const mutations = {
    setDrawer(state, val) {
        state.drawer = val
    },
    resetState(state) {
        state.drawer = false
    }
}

export default {
    namespaced: true,
    state,
    mutations
}
